module.exports = __webpack_public_path__ + "img/ziti-title.5f53ca5d.png";